import { isValidDate } from '../const'
export default function getMixin (key, {
    in_key
}) {
    return {
        data () {
            return {
                [key]: [{
                    is_monthly: '否',
                    start: '',
                    end: '',
                    val: ''
                }]
            }
        },
        computed: {
            [`${key}_count`] () {
                return this[key].length
            },
        },
        methods: {
            [`add_${key}`] () {
                if (this[`${key}_count`] >= 15) {
                    wx.showToast({
                        title: '提取记录已达上限，不能继续添加',
                        icon: 'none'
                    })
                    return
                }
                this[key].push({
                    is_monthly: '否',
                    start: '',
                    end: '',
                    val: ''
                })
            },
            [`del_${key}`] (i) {
                if (i === 0 && this[`${key}_count`] === 1) {
                    this[key].splice(i, 1, {
                        is_monthly: '否',
                        start: '',
                        end: '',
                        val: ''
                    })
                } else {
                    this[key].splice(i, 1);
                }
            },
            [`update_${key}`] (i, record) {
                const prev = this[key][i - 1]
                const next = this[key][i + 1]
                const first_in = this[in_key][this[in_key].length - 1]
                let err_msg = ''
                if (prev &&
                    (
                        (prev.start && record.end && !isValidDate(record.end, prev.start))
                        ||
                        (prev.start && record.start && !isValidDate(record.start, prev.start))
                    )
                ) {
                    err_msg = '不能超过上一笔开始时间'
                } else if (next &&
                    (
                        (next.end && record.start && !isValidDate(next.end, record.start))
                        ||
                        (next.end && record.end && !isValidDate(next.end, record.end))
                    )
                ) {
                    err_msg = '不能晚于下一笔截至时间'
                } else if (first_in.start && record.start && !isValidDate(first_in.start, record.start, true)) {
                    err_msg = '不能早于缴存时间'
                }
                if (err_msg) {
                    wx.showToast({
                        title: err_msg,
                        icon: 'none'
                    })
                    return
                }
                console.error(i, record)
                this.$set(this[key], i, record)
            }
        }
    }
}